import React from 'react';

export const createChartGradients = (data: any[], prefix: string) => {
  return data.map((item, index) => (
    <defs key={`${prefix}-gradient-def-${index}`}>
      <linearGradient id={`${prefix}-gradient-${index}`} x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor={item.color.gradient[0]} />
        <stop offset="100%" stopColor={item.color.gradient[1]} />
      </linearGradient>
    </defs>
  ));
};